import React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";

interface IPreRetirementTableProps{
    data: any[]
}

export const PreRetirementTable = (props : IPreRetirementTableProps) => {
    const total = () : number => {
        let sum = 0;
        props.data?.forEach(d => sum += d.availableValue.Amount);
        return sum;
    }

    return (
        <> 
            { props.data.length !== 0 && (
                <>
                    <h3>Savings pot</h3>
                    <div className="panel-subtle panel-scrollable pt-10 pb-10 mb-50">             
                        <div>             
                            <table className="table-subtle table-first-last-cell-padding-reset">
                                <thead>
                                    <tr>                             
                                        <th>Arrangement ID</th>                         
                                        <th>Disqualifying Pension Credit</th> 
                                        <th className="cell-right">Date opened</th>                                                                                  
                                        <th className="cell-right">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { props.data.map((row, index) => {
                                        return (                               
                                            <tr key={index}>                   
                                                <td>{row.arrangementis}</td>   
                                                <td>{row.credit}</td>                          
                                                <td className="cell-right">{row.date}</td> 
                                                <td className="cell-right">
                                                    {MoneyDisplayHelper.FromatMoneyDisplay(
                                                        row.availableValue.Amount,
                                                        CurrencyCode.GBP,
                                                        true,
                                                        2
                                                    )}
                                                </td>              
                                            </tr>
                                        )
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={3} className="cell-total">Total</td>
                                        <td className="cell-value cell-right">
                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                total(),
                                                CurrencyCode.GBP,
                                                true,
                                                2
                                            )}
                                        </td>
                                    </tr>
                                </tfoot>                                  
                            </table>            
                        </div>
                    </div>
                </>
            )}
        </>     
    );
   
} 
